module.exports = __webpack_public_path__ + "Simple-Line-Icons.2a103029dda6ab1bc9c8.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = ../../../../simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0
// module chunks = styles